module.exports = __webpack_public_path__ + "pw.svg?2c7e97aee48d185abb51fe9720a9fcb4";